import { Reducer } from 'redux';

import * as ActionTypes from '../actions/types';
import * as Actions from '../actions';
import * as Model from '../models';

type Optional<T> = T | undefined;

function getFirstOligoInOligos(projectIdx: number, oligos: Optional<Model.OligoItem[]>): Optional<Model.OligoInFocusData> {
  if (oligos && oligos.length > 0) {
    const [oligo] = oligos;
    const { id } = oligo;
    return { id, projectIdx };
  }
  return undefined;
}

function getFirstOligoInProjects(projects: Optional<Model.ProjectItem[]>): Optional<Model.OligoInFocusData> {
  if (projects && projects.length > 0) {
    const [project] = projects;
    const { oligos } = project;
    return getFirstOligoInOligos(project.index, oligos);
  }
  return undefined;
}

const updateAppState = (state: Model.WorldItem, action: Model.ReduxAction<string | object>) => {
  const appState: Model.AppState = (action as Model.ReduxAction<Actions.AppStateUpdateActionPayload>).payload;
  return { ...state, appState };
};

const updateWorldData = (state: Model.WorldItem, action: Model.ReduxAction<string | object>) => {
  const worldData: Model.WorldData = (action as Model.ReduxAction<Actions.WorldDataUpdateActionPayload>).payload;
  return { ...state, ...worldData };
};

const loadWorldItem = (state: Model.WorldItem, action: Model.ReduxAction<string | object>, oligoInFocus: Model.OligoInFocusData | undefined) => {
  state = (action as Model.ReduxAction<Actions.WorldItemLoadActionPayload>).payload;
  if (oligoInFocus && !state.oligoInFocus) {
    state.oligoInFocus = { ...oligoInFocus };
  }
  if ((oligoInFocus && state.oligoInFocus) && (state.oligoInFocus.id !== oligoInFocus.id)) {
    state.oligoInFocus = { ...oligoInFocus };
  }
  return state;
};

const deleteProject = (state: Model.WorldItem, action: Model.ReduxAction<string | object>, oligoInFocus: Model.OligoInFocusData | undefined) => {
  const { index: projectIdx } = (action as Model.ReduxAction<Actions.ProjectDeleteActionPayload>).payload;
  if (oligoInFocus && oligoInFocus.projectIdx === projectIdx) {
    oligoInFocus = undefined;
    return { ...state, oligoInFocus };
  }
  return state;
};

const addOligo = (state: Model.WorldItem, action: Model.ReduxAction<string | object>) => {
  const { projectIdx, oligos } = (action as Model.ReduxAction<Actions.OligoAddActionPayload>).payload;
  const oligoInFocus = getFirstOligoInOligos(projectIdx, oligos);
  return { ...state, oligoInFocus };
};

const deleteOligo = (state: Model.WorldItem, action: Model.ReduxAction<string | object>, oligoInFocus: Model.OligoInFocusData | undefined) => {
  const { id } = (action as Model.ReduxAction<Actions.OligoDeleteActionPayload>).payload;
  if (oligoInFocus && oligoInFocus.id === id) {
    oligoInFocus = undefined;
    return { ...state, oligoInFocus };
  }
  return state;
};

export const world: Reducer<Model.WorldItem, Model.ReduxAction<object | string>> = (state = Model.WORLD_INITIAL, action: Model.ReduxAction<object | string>) => {
  if (!action || !action.type) {
    return state;
  }
  const { type } = action;
  let { oligoInFocus } = state;
  switch (type) {
    case ActionTypes.UPDATE_APP_STATE:
      state = updateAppState(state, action);
      break;
    case ActionTypes.UPDATE_WORLD_DATA:
      state = updateWorldData(state, action);
      break;
    case ActionTypes.LOAD_WORLD_ITEM:
      // NOTE: we are checking this because when it's possible that when the browser
      // reloads, we don't really want to take the value from the storage data. we just
      // want to use the in memory values triggered by the actions
      state = loadWorldItem(state, action, oligoInFocus);
      break;
    case ActionTypes.LOAD_PROJECTS:
      oligoInFocus = getFirstOligoInProjects((action as Model.ReduxAction<Actions.ProjectsLoadActionPayload>).payload);
      state = { ...state, oligoInFocus };
      break;
    case ActionTypes.ADD_PROJECT:
      oligoInFocus = getFirstOligoInProjects([(action as Model.ReduxAction<Actions.ProjectAddActionPayload>).payload]);
      state = { ...state, oligoInFocus };
      break;
    case ActionTypes.DELETE_PROJECT:
      state = deleteProject(state, action, oligoInFocus);
      break;
    case ActionTypes.ADD_OLIGO:
      state = addOligo(state, action);
      break;
    case ActionTypes.DELETE_OLIGO:
      state = deleteOligo(state, action, oligoInFocus);
      break;
    default:
      break;
  }
  return state;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/reducers/world-reducer.ts